import React from "react";

const ArrowUpIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        d="M10.3536 5.14645C10.5488 5.34171 10.5488 5.65829 10.3536 5.85355C10.1583 6.04882 9.84171 6.04882 9.64645 5.85355L6.5 2.70711L6.5 10.5C6.5 10.7761 6.27614 11 6 11C5.72386 11 5.5 10.7761 5.5 10.5L5.5 2.70711L2.35355 5.85355C2.15829 6.04882 1.84171 6.04882 1.64645 5.85355C1.45118 5.65829 1.45118 5.34171 1.64645 5.14645L5.64645 1.14645C5.84171 0.951184 6.15829 0.951184 6.35355 1.14645L10.3536 5.14645Z"
        fill="white"
      />
    </svg>
  );
};

export default ArrowUpIcon;
